var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_6380",
    x: 14.001,
    y: 14,
    width: 26.969,
    height: 28.928,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    transform: "translate(-459 -253)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(459 253)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 459, 253)",
    filter: "url(#Path_6380)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6380-2",
    "data-name": "Path 6380",
    d: "M4620.9-977.812a2.877,2.877,0,0,1-1.281,2.3,26.437,26.437,0,0,1-2.3,1.4q-5.473,3.063-10.96,6.1c-.538.3-1.085.583-1.643.844a2.884,2.884,0,0,1-1.52.287,2.342,2.342,0,0,1-2.038-1.774,6.975,6.975,0,0,1-.193-1.971c-.023-3.733-.022-7.467-.027-11.2,0-1.1-.008-2.2.015-3.307a6.414,6.414,0,0,1,.2-1.863,2.314,2.314,0,0,1,1.992-1.78,3.014,3.014,0,0,1,1.811.4c1.544.829,3.087,1.658,4.617,2.511q4.591,2.559,9.166,5.145a4.625,4.625,0,0,1,1.588,1.284A2.94,2.94,0,0,1,4620.9-977.812Z",
    transform: "translate(-4583.43 1005.29)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.00c03e46c9f1fa235d0a0f9eabda4d6e.svg";
export { ForwardRef as ReactComponent };